import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/VariationOrderForm'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'(Potential) Variation Order Form'}
        >
            <Component 
            />
        </Layout>
    )
}

export default BlockInspectionStatusMasterlist